/**
 * Diagnostic flow-timing logger for the welcome audio gate.
 *
 * The welcome audio path is browser-dependent and has bitten us repeatedly (cold-Chrome optimistic
 * flag, the resume hang, Safari's suspended context), so we keep this timeline available — but at
 * `debug` level, so it is SILENT by default (dev defaults to `info`, prod to `warn`) and only surfaces
 * on demand via `?log=debug`. `flowStart()` resets the clock on ENTER_WELCOME; every `flowLog()` is
 * stamped with elapsed-ms since then. Logs as `[WelcomeFlow] +<ms>ms <message>`.
 *
 * Lives here (beside logger.ts), NOT in core/logic — it's an iframe-app diagnostic, so it stays out
 * of the published SDK's lib/core build.
 */
import { getLogger } from './logger';

const logger = getLogger('WelcomeFlow');
const now = (): number => (typeof performance !== 'undefined' ? performance.now() : 0);

let t0 = 0;

/** Reset the timeline (call on ENTER_WELCOME) and emit the first line. */
export function flowStart(message: string): void {
  t0 = now();
  logger.debug(`+0ms ${message}`);
}

/** Emit a timeline line stamped with elapsed-ms since flowStart(). */
export function flowLog(message: string): void {
  logger.debug(`+${Math.round(now() - t0)}ms ${message}`);
}
